// Constants
import ColumnName from '../column-name/column-name.constants';
import Kendo from '../../../constants/kendo.constants';

export default {
  columns: [
    {
      ...ColumnName.buttons,
      cell: Kendo.cellTemplateNames.buttons,
      filterable: false,
      minResizableWidth: Kendo.size.minResizableWidth,
      columnMenu: false,
      selected: true,
      width: Kendo.size.width.buttons
    },
    {
      ...ColumnName.User.userId,
      filter: Kendo.filter.numeric,
      filterable: false, // isActive is just visible, it is filtered by the global filter
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: false,
      width: Kendo.size.width.default
    },
    /* This section was auto-generated by bzs-helper ($Properties$) */
    {
      ...ColumnName.User.username,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.User.email,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.User.customerId,
      filter: Kendo.filter.numeric,
      filterable: false,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: false,
      width: Kendo.size.width.int
    },
    {
      ...ColumnName.User.customerCode,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.User.customerName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.User.thirdParty,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.User.hasAdministratorAccess,
      filter: Kendo.filter.boolean,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.boolean
    },
    {
      ...ColumnName.User.hasGlobalAccess,
      filter: Kendo.filter.boolean,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.boolean
    },
    {
      ...ColumnName.User.hasThirdPartyAccess,
      filter: Kendo.filter.boolean,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.boolean
    },
    {
      ...ColumnName.User.createdOn,
      filter: Kendo.filter.date,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.date
    },
    {
      ...ColumnName.User.modifiedOn,
      filter: Kendo.filter.date,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.date
    }
  ],
  doClientSide: false,
  filter: {
    logic: 'and',
    filters: []
  },
  paging: {
    pageSize: 10,
    skip: 0,
    take: 10
  },
  searchHeader: 'Search Users',
  searchPlaceholder: 'Enter keywords...',
  sort: [{ field: ColumnName.User.username.field, dir: Kendo.sort.asc }],
  title: 'Users Grid'
};
